import { MessageCircle, X } from "lucide-react";
import { useState, useEffect, useCallback } from "react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const FloatingWhatsApp = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    fetchWhatsAppSettings();
  }, []);

  const fetchWhatsAppSettings = async () => {
    try {
      const response = await axios.get(`${API}/whatsapp-settings`);
      if (response.data && response.data.is_active && response.data.phone_number) {
        setSettings(response.data);
      }
    } catch (error) {
      console.error("WhatsApp settings error:", error);
    }
  };

  const handleWhatsAppClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    
    if (!settings || !settings.phone_number) {
      console.log("WhatsApp numarası bulunamadı");
      return;
    }
    
    const defaultMessage = "Merhaba! Alcodot hakkında bilgi almak istiyorum.";
    const cleanNumber = settings.phone_number.replace(/\D/g, '');
    
    // Doğru WhatsApp URL formatı
    const url = `https://wa.me/${cleanNumber}?text=${encodeURIComponent(defaultMessage)}`;
    
    console.log("WhatsApp URL:", url);
    console.log("Temiz numara:", cleanNumber);
    
    // Yeni sekmede aç
    const newWindow = window.open(url, '_blank');
    if (newWindow) {
      newWindow.opener = null; // Güvenlik için
    }
  };

  const handleToggle = useCallback((e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    setIsOpen(prev => {
      console.log('WhatsApp toggle:', !prev);
      return !prev;
    });
  }, []);

  const handleClose = useCallback((e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    console.log('WhatsApp closing...');
    setIsOpen(false);
  }, []);

  // Eğer ayarlar yoksa veya aktif değilse bot'u gösterme
  if (!settings || !settings.is_active || !settings.phone_number) {
    return null;
  }

  return (
    <div className="fixed bottom-6 right-6 z-50" data-testid="whatsapp-float">
      {/* Chat Preview */}
      {isOpen && (
        <div className="mb-4 glass-card-premium rounded-2xl p-4 w-72 neon-border shadow-2xl slide-up">
          <div className="flex items-center justify-between mb-3">
            <div className="flex items-center gap-2">
              <div className="w-10 h-10 bg-gradient-to-br from-green-500 to-emerald-600 rounded-full flex items-center justify-center">
                <MessageCircle className="w-5 h-5 text-white" />
              </div>
              <div>
                <p className="text-white font-bold text-sm">Alcodot Destek</p>
                <p className="text-green-400 text-xs">● Online</p>
              </div>
            </div>
            <button
              onClick={handleClose}
              className="text-gray-400 hover:text-white smooth-transition"
              type="button"
              data-testid="whatsapp-close-btn"
            >
              <X className="w-5 h-5" />
            </button>
          </div>
          <p className="text-gray-300 text-sm mb-4">
            Merhaba! 👋<br />
            Size nasıl yardımcı olabiliriz?
          </p>
          <button
            onClick={handleWhatsAppClick}
            type="button"
            className="w-full bg-gradient-to-r from-green-500 to-emerald-600 hover:from-green-600 hover:to-emerald-700 text-white font-bold py-3 px-4 rounded-xl smooth-transition flex items-center justify-center gap-2"
            data-testid="whatsapp-chat-btn"
          >
            <MessageCircle className="w-5 h-5" />
            WhatsApp'tan Yazın
          </button>
        </div>
      )}

      {/* Main Button */}
      <button
        onClick={handleToggle}
        type="button"
        className="w-16 h-16 bg-gradient-to-br from-green-500 to-emerald-600 hover:from-green-600 hover:to-emerald-700 rounded-full shadow-2xl flex items-center justify-center smooth-transition hover:scale-110 relative"
        style={{ boxShadow: '0 0 30px rgba(34, 197, 94, 0.6)' }}
        data-testid="whatsapp-toggle-btn"
      >
        {isOpen ? (
          <X className="w-7 h-7 text-white" />
        ) : (
          <MessageCircle className="w-7 h-7 text-white" />
        )}
        
        {/* Pulse ring - sadece kapalıyken */}
        {!isOpen && (
          <div className="absolute inset-0 rounded-full bg-green-500/30 animate-ping pointer-events-none"></div>
        )}
      </button>
    </div>
  );
};

export default FloatingWhatsApp;